import { history } from 'store'
import { FETCH_MAILBOX, FETCH_CARDS_SUCCESS, FETCH_CONVERSATION_SUCCESS, SEND_MESSAGE } from './types'
import { MESSAGE_TYPES } from 'common/constants'
import { objectReducer } from 'utils'

const supportedTypes = Object.values(MESSAGE_TYPES)
const processMessages = messages =>
  messages.filter(m => supportedTypes.includes(m.typeId)).sort((a, b) => a.creationDate - b.creationDate)

const mailbox = objectReducer(
  FETCH_MAILBOX,
  { conversations: [], cards: [], loaded: false },
  {
    success({ mails, users }, state) {
      const conversations = Object.entries(users)
        .map(([id, user]) => ({
          user,
          messages: processMessages(mails.filter(e => e.fromUserId == id || e.toUserId == id)),
        }))
        .filter(c => c.messages.length) // hide conversations with only unsupported messages
      return { ...state, conversations, loaded: true }
    },
    extra(state, { type, meta, payload }) {
      if (type == FETCH_CARDS_SUCCESS) {
        return { ...state, cards: payload.map(c => ({ ...c, src: `/images/cards/${c.name}` })) }
      }
      if (type.includes(SEND_MESSAGE)) {
        const sending = type == SEND_MESSAGE

        const conversation = state.conversations.find(c => c.user.id == meta.data.toUserId) || {
          user: { id: meta.data.toUserId },
          messages: [],
        }
        const message = { ...meta.data, sending, failed: /ERROR/.test(type), creationDate: +new Date(), id: 0 }
        const messages = [...conversation.messages.filter(e => !e.sending), message]
        const newConversation = { ...conversation, messages }

        if (payload ? !payload.success : 0) {
          setTimeout(() => history.push(payload.url))
        }
        return {
          ...state,
          conversations: state.conversations.map(c => (c != conversation ? c : newConversation)),
        }
      }
      if (type == FETCH_CONVERSATION_SUCCESS) {
        return {
          ...state,
          conversations: state.conversations.map(c =>
            c.user.nickname != meta.nickname ? c : { user: c.user, messages: processMessages(payload) }
          ),
        }
      }
      return state
    },
  }
)

export default mailbox
